import { render } from "./NewBundleModal.vue?vue&type=template&id=b391f452"
import script from "./NewBundleModal.vue?vue&type=script&lang=js"
export * from "./NewBundleModal.vue?vue&type=script&lang=js"

import "./NewBundleModal.vue?vue&type=style&index=0&id=b391f452&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__